// extracted by mini-css-extract-plugin
export default {"left_box":"index_left_box_gggC3","dbox":"index_dbox_vw9u-","adBox":"index_adBox_NFSd-"};